import { render, staticRenderFns } from "./Demography.vue?vue&type=template&id=223f005a&"
import script from "./Demography.vue?vue&type=script&lang=js&"
export * from "./Demography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports